document.addEventListener("DOMContentLoaded", function() {
  console.log("🚀 Add-ons script loaded");

  document.querySelectorAll("product-form form").forEach(productForm => {
    const addonCheckboxes = productForm.querySelectorAll(".addon-checkbox");
    console.log("Found checkboxes:", addonCheckboxes.length);

    if (!addonCheckboxes.length) return;

    productForm.addEventListener("submit", function(e) {
      e.preventDefault();
      console.log("🛒 Form submitted");

      let items = [];

      // Main product
      const mainVariantId = productForm.querySelector("[name='id']").value;
      console.log("Main variant ID:", mainVariantId);
      items.push({ id: mainVariantId, quantity: 1 });

      // Addons
      addonCheckboxes.forEach(cb => {
        if (cb.checked) {
          console.log("✅ Addon selected:", cb.value);
          items.push({ id: cb.value, quantity: 1 });
        }
      });

      console.log("Final items to add:", items);

      // Send all to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Shopify response:", data);
        window.location.href = "/cart";
      })
      .catch(err => console.error("❌ Error adding to cart:", err));
    });
  });
});
